<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<div class="queue-header">
  <header class="page-header">
    <h2>Comitê de crédito</h2>
  </header>
  <div class="queue-header__actions">
    <app-button
      [label]="'Atualizar'"
      [icon]="'refresh'"
      [theme]="'outline-grey'"
      [disabled]="loading()"
      [type]="'button'"
      (sendButtonClick)="load()" />
    @if (canConfigure()) {
      <app-button
        [label]="'Configurar comitê'"
        [icon]="'cog'"
        [theme]="'outline-grey'"
        [routerLink]="'/dashboard/management/back-office/support/parametrizacao'"
        [queryParams]="{ open: 'credit-committee' }"
        [type]="'button'" />
    }
  </div>
</div>

@if (loading()) {
  <div class="queue-state">
    <app-cog-loading-spinner [size]="64" />
    <p>Carregando a fila do comitê...</p>
  </div>
} @else if (error()) {
  <div class="queue-state" role="alert">
    <strong class="queue-error">{{ error() }}</strong>
    <app-button
      [label]="'Tentar de novo'"
      [theme]="'outline-grey'"
      [type]="'button'"
      (sendButtonClick)="load()" />
  </div>
} @else {
  @let k = kpis();
  <div class="kpis">
    <div class="kpi">
      <p class="kpi__label">Aguardando o seu voto</p>
      <p class="kpi__value">{{ k.awaitingMyVote }}</p>
      <p class="kpi__sub" [class.kpi__sub--danger]="k.awaitingMyVoteOverdue > 0">
        {{
          k.awaitingMyVoteOverdue > 0
            ? k.awaitingMyVoteOverdue + ' com prazo vencido'
            : 'nenhum com prazo vencido'
        }}
      </p>
    </div>
    <div class="kpi">
      <p class="kpi__label">Contestações em aberto</p>
      <p class="kpi__value">{{ k.openContests }}</p>
      <p class="kpi__sub">com o comercial</p>
    </div>
    <div class="kpi">
      <p class="kpi__label">Prazo vencido</p>
      <p class="kpi__value" [class.kpi__value--danger]="k.overdue > 0">{{ k.overdue }}</p>
      <p class="kpi__sub">
        {{ k.overdue > 0 ? 'sócios e comercial avisados do atraso' : 'nenhum deal atrasado' }}
      </p>
    </div>
    <div class="kpi">
      <p class="kpi__label">Decididos nos últimos 30 dias</p>
      <p class="kpi__value">{{ k.decided }}</p>
      <p class="kpi__sub">
        {{ k.approved }} {{ k.approved === 1 ? 'aprovado' : 'aprovados' }} · {{ k.denied }}
        {{ k.denied === 1 ? 'negado' : 'negados' }}
      </p>
    </div>
  </div>

  <div class="queue-filters" role="group" aria-label="Filtrar a fila">
    @for (f of filters; track f.value) {
      <app-button
        [label]="f.label + ' ' + countFor(f.value)"
        [theme]="filter() === f.value ? 'darkblue' : 'outline-grey'"
        [selected]="filter() === f.value"
        [size]="'small'"
        [type]="'button'"
        (sendButtonClick)="selectFilter(f.value)" />
    }
  </div>

  @if (rows().length) {
    <div class="queue-table-wrap">
      <table class="queue-table">
        <thead>
          <tr>
            <th>Deal</th>
            <th class="queue-table__num">Valor</th>
            <th>{{ filter() === 'decided' ? 'Decidido em' : 'Prazo do voto' }}</th>
            <th>Situação</th>
            <th><span class="sr-only">Ação</span></th>
          </tr>
        </thead>
        <tbody>
          @for (item of rows(); track item.dealId + '-' + item.round) {
            @let s = situation(item);
            <tr>
              <td>
                <a
                  class="queue-table__deal"
                  [routerLink]="dealRoute(item)"
                  [queryParams]="{ stage: 'committee' }">
                  {{ item.companyName }}
                </a>
                <span class="queue-table__meta">
                  {{ votes(item) }}
                  @if (item.round > 1) {
                    · rodada {{ item.round }}
                  }
                </span>
              </td>
              <td class="queue-table__num">
                {{ item.amount | currency: item.currencyCode : 'symbol' : '1.0-0' : 'pt-BR' }}
              </td>
              <td
                class="queue-table__date"
                [class.queue-table__date--danger]="item.isOverdue && item.status === 'Open'">
                {{ (filter() === 'decided' ? item.decidedAt : item.deadlineAt) | vaultDateTime }}
              </td>
              <td>
                <span class="queue-tag queue-tag--{{ s.tone }}">{{ s.label }}</span>
              </td>
              <td class="queue-table__action">
                <app-button
                  [label]="awaitingMyVote(item) ? 'Votar' : 'Abrir'"
                  [theme]="awaitingMyVote(item) ? 'darkblue' : 'outline-grey'"
                  [size]="'small'"
                  [routerLink]="dealRoute(item)"
                  [queryParams]="{ stage: 'committee' }"
                  [type]="'button'" />
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <p class="queue-empty">{{ emptyText() }}</p>
  }
}
